import { PortfolioLayout } from "./PortfolioLayout";
import { PortfolioContact } from "./PortfolioSections";

export default function PortfolioContactPage() {
  return <PortfolioLayout path="/contact" title="Contact | Tokam Darius" description="Parlons de votre application web, de votre automatisation ou d'une collaboration. Contactez Tokam Darius, développeur basé à Jonquière."><PortfolioContact /></PortfolioLayout>;
}
